/*
  src/redux/auth/reducer.js

  Created by Justin Chang on 5/17/2017.
*/
import update from '../update';

import {
  SET_AUTH_TOKEN,
  SET_USER_ID,
  SET_SESSION_ID,
  INVALIDATE_ALL_AUTH
} from './constants';

const initialState = {
  token:     null,
  userId:    null,
  sessId:    null,
};

export default function(state=initialState, action){
  switch(action.type){

    case SET_AUTH_TOKEN:
      return update(state, {
        token: {$set: action.payload}
      });

    case SET_USER_ID:
      return update(state, {
        userId: {$set: action.payload}
      });

    case SET_SESSION_ID:
      return update(state, {
        sessId: {$set: action.payload}
      });

    case INVALIDATE_ALL_AUTH:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/reducer.js